module.exports = __webpack_public_path__ + "img/kenguru-header-logo.829663a3.svg";